import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiClientInterface } from '../../client/api/api-client.interface';
import { AdvisoryModel, ClientSignatureType, IdInterface, OrderSignedInterface, TestInterface, TestResultInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { TransactionRequestInterface } from '../transaction/transaction-request.interface';

@Injectable()
export class TestApiRepository {
    constructor(private apiClient: ApiClientInterface, private transactionRequest: TransactionRequestInterface) {}

    load(clientId: IdInterface, advisoryModel: AdvisoryModel): Observable<Transaction<TestInterface>> {
        return this.transactionRequest.wrap(this.apiClient.getTest(clientId, advisoryModel));
    }

    sign(clientCode: IdInterface, signatureType: ClientSignatureType): Observable<Transaction<void>> {
        return new Observable((observer) => {
            this.transactionRequest.wrap(this.apiClient.signTest(clientCode, signatureType)).subscribe((transaction) => {
                if (transaction.isSuccess) {
                    observer.next(Transaction.success());
                } else {
                    observer.next(Transaction.error(transaction.error));
                }

                observer.complete();
            });
        });
    }

    continue(clientCode: IdInterface): Observable<Transaction<OrderSignedInterface>> {
        return this.transactionRequest.wrap(this.apiClient.continueTestElectronicSignature(clientCode));
    }

    acceptSignatories(clientCode: IdInterface): Observable<Transaction<void>> {
        return new Observable((observer) => {
            this.transactionRequest.wrap(this.apiClient.acceptTestSignSignatures(clientCode)).subscribe((transaction) => {
                if (transaction.isSuccess) {
                    observer.next(Transaction.success());
                } else {
                    observer.next(Transaction.error(transaction.error));
                }

                observer.complete();
            });
        });
    }

    documents(clientCode: IdInterface): Observable<Transaction<any>> {
        return this.transactionRequest.wrap(this.apiClient.getTestSignDocuments(clientCode));
    }

    results(clientId: IdInterface, advisoryModel: AdvisoryModel): Observable<Transaction<TestResultInterface>> {
        return this.transactionRequest.wrap(this.apiClient.getTestResults(clientId, advisoryModel));
    }

    update(clientId: IdInterface, test: TestInterface, requiredSignature: boolean): Observable<Transaction<TestResultInterface>> {
        return this.transactionRequest.wrap(this.apiClient.updateTest(clientId, test, requiredSignature));
    }

    upload(clientCode: IdInterface, document: File): Observable<Transaction<void>> {
        return new Observable((observer) => {
            this.transactionRequest.wrap(this.apiClient.uploadTestSignDocument(clientCode, document)).subscribe((transaction) => {
                if (transaction.isSuccess) {
                    observer.next(Transaction.success());
                } else {
                    observer.next(Transaction.error(transaction.error));
                }

                observer.complete();
            });
        });
    }
}
